import { USER_DATA_RECEIVED, USER_DATA_UNLOADED, USER_INFO_RECEIVED, USER_INFO_UNLOADED, USER_RESTOREPOINT, USER_DEVICES_RECEIVED, USER_DEVICES_DELETED, USER_DEVICES_UNLOADED, PERSON_SAVED, BOTH_USER_SAVED, PRIMARY_SAVED, PARTNER_SAVED } from './types';
import api from 'api';

export const userDataReceived = (user_data) => ({
  type: USER_DATA_RECEIVED,
  user_data
})

export const userDataUnload = () => ({
  type: USER_DATA_UNLOADED
})

export const userRestorePoint = restorePoint => ({
  type: USER_RESTOREPOINT,
  restorePoint
})

export const userInfoReceived = (user_info) => ({
  type: USER_INFO_RECEIVED,
  user_info
})

export const userInfoUnload = () => ({
  type: USER_INFO_UNLOADED
})

export const unloadUserData = () => dispatch => {
  dispatch(userDataUnload())
}

// TODO: catch with user logout and user data not recived
export const getUserData = () => (dispatch) =>
  api.bmc.user.getUserData().then( user_data => {
    const { reloadId } = sessionStorage
    if (!!reloadId) {
      sessionStorage.setItem('planId', reloadId)
      sessionStorage.removeItem('reloadId')
    } else {
      sessionStorage.setItem('planId', user_data.futureChoicesID)
    }
    
    dispatch(userDataReceived(user_data))
})

export const getViewProspectData = () => (dispatch) =>
  api.rnc.advisor.getViewProspectData().then( user_data => {
    sessionStorage.setItem('planId', 'view')
    dispatch(userDataReceived(user_data))
})

export const unloadUserInfo = () => dispatch => {
  dispatch(userInfoUnload())
}

export const getRestorePoint = () => dispatch => 
  api.bmc.user.getRestorePoint().then(restorePoint => {
     dispatch(userRestorePoint(restorePoint))
  })
export const getUserInfo = () => (dispatch) =>
  api.bmc.user.getUserInfo().then( user_info => {
    dispatch(userInfoReceived(user_info))
});

export const deletePartner = data => dispatch =>
  api.bmc.user.deletePartner(data).then(res=>{
    dispatch(getUserData())
  })

export const personSaved = data => ({
  type: PERSON_SAVED,
  data
})

export const primarySaved = data => ({
  type: PRIMARY_SAVED,
  data
})

export const partnerSaved = data => ({
  type: PARTNER_SAVED,
  data
})

export const bothUserSaved = data => ({
  type: BOTH_USER_SAVED,
  data
})

export const saveUserDetails = ({partner, primary}) => dispatch => {
  if(partner === null || (partner.name.length === 0 && partner.dateOfBirth.length === 0) ){
    return api.bmc.user.postPerson(primary).then(res=>dispatch(primarySaved(res)))
  }else{
    return Promise.all([api.bmc.user.postPerson(primary), api.bmc.user.postPerson(partner)])
      .then(res => dispatch(bothUserSaved(res)))
  }
}

export const postPerson = data => dispatch =>
  api.bmc.user.postPerson(data).then(person=>{
    switch (person.relationship) {
      case 'primary':
        dispatch(primarySaved(person))
        break
      case 'partner':
        dispatch(partnerSaved(person))
        break
      default:
        dispatch(personSaved(person))
    }
    return person
  })

export const deletePerson = data => dispatch =>
  api.bmc.user.deletePerson(data).then( person =>{
    dispatch(getUserData())
  })

export const userDevicesReceived = (user_devices) => ({
  type: USER_DEVICES_RECEIVED,
  user_devices
})

export const userDevicesUnload = () => ({
  type: USER_DEVICES_UNLOADED
})

export const userDeviceDeleted = code => ({
  type: USER_DEVICES_DELETED,
  code
})

export const unloadUserDevices = () => dispatch => {
  dispatch(userDevicesUnload())
}

export const getUserDevices = () => (dispatch) =>
  api.account.getUserDevices().then( user_devices => {
    dispatch(userDevicesReceived(user_devices))
});

export const forgetDevice = code => dispatch =>
  api.account.forgetDevice(code).then(res=>{
    dispatch(userDeviceDeleted(code))
  })